// extracted by mini-css-extract-plugin
export default {"contracts":"ContractManagementFinancial_contracts__DTU9O"};